import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { reportDWH } from './checkFiberInfrastructureSlice';
import { setPersonalInfo, createLead } from './checkFiberInfrastructureSlice';
import LeadForm from '../SaleJetBlock/Partials/LeadForm/LeadForm';
import WhatsApp from '../SaleJetBlock/Partials/WhatsApp/WhatsApp';
import LeadSuccess from '../SaleJetBlock/Partials/LeadSuccess/LeadSuccess';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import { gtag4 } from '../../../utilities/analytics/tracking';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';

const LeadPage = (props) => {
    const [step, setStep] = useState(props.isWhatsAppActive ? 'WhatsApp' : 'LeadForm');
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        if (step == 'WhatsApp') {
            props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Whatsapp Display' });
            gtag4({ event: 'Address_Check_Step3_NoSivimWhatsappPage', step: '3', action: 'NoSivimWhatsappPage', funnel_name: 'No_Sivim' });
        }
        else {
            props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber- Lead Form Display' });
            gtag4({ event: 'Address_Check_Step4_LeadPage', step: '4', action: 'LeadPage', funnel_name: 'No_Sivim' });
        }
    }, []);

    //page params
    let isDisplayFooter = false;
    let isDisplayWhatsAppIcon = (props.isWhatsAppActive && step == 'WhatsApp');
    let btnText = '';
    let currentPageFunction = handlePageContinue;
    let bottomLink = null;
    //page params

    if (props.isWhatsAppActive) {
        if (step == 'WhatsApp') {
            bottomLink = { text: 'שנציג יחזור אלי', onclick: handleLeadFormClick };
        }
        else {
            bottomLink = { text: 'בא לי Whatsapp', onclick: handleWhatsAppClick };
        }
    }
    let title = '';
    let subTitle = '';
    if (step == 'LeadForm') {
        if (props.isWhatsAppActive) {
            title = <> אני רוצה שתחזרו אליי </>;
        }
        else {
            title = <> הסיב שלנו יגיע בקרוב עד אליך </>;
            subTitle = <> כמה פרטים, ונעדכן אותך מיד כשזה יקרה. </>;
        }
    }

    let currentPageHeadline = null;
    if (title || subTitle) {
        currentPageHeadline = (
            <div className='page-headline-wrapper'>
                {title && <h1 className='page-title'> {title} </h1>}
                {subTitle && <h2 className='page-sub-title'> {subTitle} </h2>}
            </div>
        );
    }

    const getStep = () => {
        switch (step) {
            case 'LeadForm':
                isDisplayFooter = true;
                btnText = 'תחזרו אלי';
                return <LeadForm onSubmit={isSubmit} onValid={handlePageValidate} />;
            case 'LeadSuccess':
                btnText = 'חזרה לעמוד הראשי';
                isDisplayFooter = true;
                bottomLink = null;

                if (props.isWhatsAppActive) {
                    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Sent Lead Form on Service Time' });
                } else {
                    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Sent Lead Form' });
                }
                gtag4({ event: 'Address_Check_Step4_LeadSent', step: '4', action: 'LeadSent', funnel_name: 'No_Sivim' });
                return <LeadSuccess onSubmit={isSubmit} onValid={handlePageValidate} />;
            case 'WhatsApp':
                btnText = 'נמשיך ב-WhatsApp';
                isDisplayFooter = true;
                currentPageFunction = handleOpenWhatsApp;
                return <WhatsApp />;
        }
    };

    let currentPageView = <div>{getStep()}</div>;

    return (
        <>
            {currentPageHeadline}
            <div>
                {currentPageView}

                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text={btnText}
                        onclick={currentPageFunction}
                        formid='checkFiberInfrastructure'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={isDisplayWhatsAppIcon}
                    />
                    {
                        bottomLink &&
                        <div className='whatsapp-link-wrapper'>
                            <a href='#' onClick={bottomLink.onclick}>{bottomLink.text}</a>
                        </div>
                    }
                </div>
            </div>
        </>
    );

    async function handlePageValidate(data) {
        setIsSubmit(false);
        switch (step) {
            case 'LeadForm':
                if (data.isValid) {
                    props.setPersonalInfo({ firstName: data.data.firstName, lastName: data.data.lastName, subscriberNo: data.data.phoneNumber });
                    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'Customer Info Sent' });
                    gtag4({ event: 'Address_Check_Step3_LeadFormButton', action: 'LeadFormButton', funnel_name: 'No_Sivim' });
                    let createLead = await props.createLead();
                    if (createLead?.payload?.Body?.isSuccess) {
                        setStep('LeadSuccess');

                    }
                }
                break;
            case 'LeadSuccess':
                gtag4({ event: 'Address_Check_Step4_HpButton', step: '4', action: 'HpButton', funnel_name: 'No_Sivim' });
                EpiContext.navigateTo(EpiContext.getSpaBasePath());
                break;
        }
    }

    function handlePageContinue() {
        setIsSubmit(true);
    }

    function handleOpenWhatsApp() {
        props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Open Whatsapp Clicked From Form' });
        gtag4({ event: 'Address_Check_Step4_WhatsappCallClick', step: '4', button: 'בא לי Whatsapp', action: 'WhatsappCallClick', funnel_name: 'No_Sivim' });
        //const whatsAppLink = `https://wa.me/${Config.whatsAppSale}?force_isolation=true`;
        //const whatsAppLink = `https://wa.me/${Config.whatsAppSale}?force_isolation=true&text=%D7%94%D7%99%D7%99%2C%20%D7%A8%D7%A6%D7%99%D7%A0%D7%95%20%D7%9C%D7%95%D7%95%D7%93%D7%90%20%D7%A9%D7%96%D7%95%20%D7%94%D7%9B%D7%AA%D7%95%D7%91%D7%AA%20%D7%A9%D7%94%D7%96%D7%A0%D7%AA%20%D7%9C%D7%91%D7%93%D7%99%D7%A7%D7%AA%20%D7%A1%D7%99%D7%91%D7%99%D7%9D%3A%20%D7%A8%D7%97%D7%95%D7%91%20${props.selectedAddress.streetName}%20%D7%9E%D7%A1%20${props.selectedAddress.home}%20%D7%93%D7%99%D7%A8%D7%94%20${props.selectedAddress.apartment}%20%D7%A2%D7%99%D7%A8%20${props.selectedAddress.cityName}.%20%D7%94%D7%A7%D7%9C%D7%99%D7%A7%D7%95%20%22%D7%A9%D7%9C%D7%97%22`;
        const whatsAppLink = `https://wa.me/${Config.whatsAppSale}?force_isolation=true&text=%D7%A0%D7%A9%D7%9E%D7%97+%D7%9C%D7%A7%D7%97%D7%AA+%D7%90%D7%AA+%D7%96%D7%94+%D7%94%D7%9C%D7%90%D7%94+%2C%D7%A8%D7%A7+%D7%9C%D7%A4%D7%A0%D7%99+%D7%9B%D7%9F+%D7%A0%D7%95%D7%95%D7%93%D7%90+%D7%A9%D7%96%D7%95+%D7%94%D7%9B%D7%AA%D7%95%D7%91%D7%AA+%D7%94%D7%A0%D7%9B%D7%95%D7%A0%D7%94+%D7%9C%D7%91%D7%93%D7%99%D7%A7%D7%AA+%D7%94%D7%A1%D7%99%D7%91%D7%99%D7%9D%3A+%D7%A8%D7%97%D7%95%D7%91+${props.selectedAddress.streetName}+%D7%9E%D7%A1+${props.selectedAddress.home}+%D7%93%D7%99%D7%A8%D7%94+${props.selectedAddress.apartment}+%D7%A2%D7%99%D7%A8+${props.selectedAddress.cityName}.+%D7%94%D7%A7%D7%9C%D7%99%D7%A7%D7%95+%D7%A9%D7%9C%D7%97`;
        let win = window.open(whatsAppLink, '_blank');
        win.focus();
    }

    function handleLeadFormClick(event) {
        event.preventDefault();
        props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Open Lead Form' });
        gtag4({ event: 'Address_Check_Step3_RepClick', step: '3', button: 'שנציג יחזור אלי', action: 'RepClick', funnel_name: 'No_Sivim' });
        setStep('LeadForm');
    }

    function handleWhatsAppClick(event) {
        event.preventDefault();
        props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Whatsapp Clicked' });
        gtag4({ event: 'Address_Check_Step3_WhatsappClick', step: '3', button: 'בא לי Whatsapp', action: 'WhatsappClick', funnel_name: 'No_Sivim' });
        setStep('WhatsApp');
    }

};

const mapStateToProps = (state) => {
    return {
        isWhatsAppActive: state.checkFiberInfrastructureBlock.isWhatsAppActive,
        selectedAddress: state.checkFiberInfrastructureBlock.addressPage.selectedAddress,
    };
};

const mapDispatchToProps = {
    setPersonalInfo,
    createLead,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadPage);
